export const useGetLanguageFromCookie = () => {
    const languageCookie = document.cookie.split(';').find((cookie) => cookie.trim().startsWith('language='));
    if (languageCookie) {
        return languageCookie.split('=')[1];
    }
    return null;
};
